/**
 * @file Dismissible component with persistent localStorage state.
 */

import { Component } from 'react';
import PropTypes from 'prop-types';
import store from 'store';

export const STORE_NAMESPACE = '__WALDO_APP__';

class DismissiblePersistent extends Component {
  static propTypes = {
    storeKey: PropTypes.string.isRequired,
    children: PropTypes.func.isRequired,
    alwaysRender: PropTypes.bool,
  };

  state = {
    // Start the component always hidden, since its
    // visibility state depends on client-side data
    // (i.e. localStorage, etc). Its actual visibility
    // is determined on the client via componentDidMount
    visible: false,
  };

  componentDidMount() {
    if (!this.isDismissed()) {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState(() => ({
        visible: true,
      }));
    }
  }

  onDismiss = () => {
    const { storeKey } = this.props;

    this.setState(
      () => ({
        visible: false,
      }),
      () => {
        const localStore = store.get(STORE_NAMESPACE) || {};
        const { dismissedKeys = [] } = localStore;

        store.set(STORE_NAMESPACE, {
          ...localStore,
          dismissedKeys: [...dismissedKeys, storeKey],
        });
      },
    );
  };

  isDismissed = () => {
    const { storeKey } = this.props;
    const { dismissedKeys = [] } = store.get(STORE_NAMESPACE) || {};

    return dismissedKeys.includes(storeKey);
  };

  render() {
    const { visible } = this.state;
    const { children, alwaysRender } = this.props;

    if (!visible && !alwaysRender) {
      return null;
    }

    return children(this.onDismiss, visible);
  }
}

export default DismissiblePersistent;
